import { useState, useEffect } from "react";
import { getParam, setParam, getDefaults, resetParams } from "../utils/parametros";
import {
  getConfiguracaoTelegram, setConfiguracao, testarTelegram, enviarPrazosAgora,
  getColaboradoresTelegram, setColaboradorTelegram,
} from "../api/configuracao.api";

const INTERVALO_OPTS = [
  { v:"1",l:"A cada 1 hora" }, { v:"2",l:"A cada 2 horas" }, { v:"4",l:"A cada 4 horas" },
  { v:"8",l:"A cada 8 horas" }, { v:"12",l:"A cada 12 horas" }, { v:"24",l:"Uma vez por dia" },
];

export default function Parametros() {
  /* ── Parâmetros locais ── */
  const [form,   setForm]   = useState({ sprints_historico: getParam("sprints_historico") });
  const [status, setStatus] = useState(null);

  function salvarParams() {
    setParam("sprints_historico", Math.max(1, Math.min(10, Number(form.sprints_historico))));
    setStatus("ok");
    setTimeout(() => setStatus(null), 2500);
  }

  function restaurarPadroes() {
    resetParams();
    setForm({ sprints_historico: getDefaults().sprints_historico });
    setStatus("reset");
    setTimeout(() => setStatus(null), 2500);
  }

  return (
    <div style={page}>

      <div>
        <h1 style={pageTitle}>Parâmetros Gerais</h1>
        <div style={pageSub}>Configurações globais do sistema</div>
      </div>

      {/* ══ Seção: Histórico de Sprints ══ */}
      <div style={card}>
        <div style={sectionTitle}>Histórico de Sprints</div>

        <div style={fieldRow}>
          <div style={{ flex: 1 }}>
            <label style={fieldLabel}>Número de sprints para analisar</label>
            <div style={fieldHint}>Exibido na página Histórico. A API retorna até 5 sprints.</div>
          </div>
          <input
            type="number"
            min={1} max={10}
            style={numInput}
            value={form.sprints_historico}
            onChange={e => setForm(f => ({ ...f, sprints_historico: Math.max(1, Math.min(10, Number(e.target.value))) }))}
          />
        </div>
      </div>

      {/* ══ Seção: Notificações Telegram ══ */}
      <TelegramSection />

      {/* ── Footer ── */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <button style={btnSecundario} onClick={restaurarPadroes}>↺ Restaurar padrões</button>
        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
          {status && (
            <span style={{ fontSize:13, color: status === "ok" ? "#4ade80" : "#60a5fa" }}>
              {status === "ok" ? "✅ Parâmetros salvos." : "↺ Padrões restaurados."}
            </span>
          )}
          <button style={btnPrimario} onClick={salvarParams}>💾 Salvar parâmetros</button>
        </div>
      </div>

    </div>
  );
}

/* ─── Seção Telegram (inline, não modal) ─────────────────────────── */

function TelegramSection() {
  const [cfg,     setCfg]     = useState(null);
  const [form,    setForm]    = useState(null);
  const [saving,  setSaving]  = useState(false);
  const [testing, setTesting] = useState(false);
  const [sending, setSending] = useState(false);
  const [msg,     setMsg]     = useState(null);

  useEffect(() => {
    getConfiguracaoTelegram()
      .then(data => {
        setCfg(data);
        setForm({
          token:       "",
          chat_id:     data.telegram_chat_id                || "",
          intervalo:   data.telegram_prazos_intervalo_horas || "1",
          hora_inicio: data.telegram_hora_inicio            || "8",
          hora_fim:    data.telegram_hora_fim               || "21",
          ativo:       data.telegram_prazos_ativo === "true",
        });
      })
      .catch(() => setMsg({ tipo:"erro", texto:"Erro ao carregar configurações do Telegram." }));
  }, []);

  async function handleSave() {
    setSaving(true); setMsg(null);
    try {
      const ops = [];
      if (form.token.trim())
        ops.push(setConfiguracao("telegram_bot_token", form.token.trim()));
      if (form.chat_id !== (cfg?.telegram_chat_id || ""))
        ops.push(setConfiguracao("telegram_chat_id", form.chat_id.trim()));
      if (form.intervalo !== (cfg?.telegram_prazos_intervalo_horas || "1"))
        ops.push(setConfiguracao("telegram_prazos_intervalo_horas", form.intervalo));
      if (form.hora_inicio !== (cfg?.telegram_hora_inicio || "8"))
        ops.push(setConfiguracao("telegram_hora_inicio", form.hora_inicio));
      if (form.hora_fim !== (cfg?.telegram_hora_fim || "21"))
        ops.push(setConfiguracao("telegram_hora_fim", form.hora_fim));
      ops.push(setConfiguracao("telegram_prazos_ativo", String(form.ativo)));
      await Promise.all(ops);
      const novo = await getConfiguracaoTelegram();
      setCfg(novo);
      if (form.token.trim()) setForm(f => ({ ...f, token: "" }));
      setMsg({ tipo:"ok", texto:"Configurações do Telegram salvas." });
    } catch {
      setMsg({ tipo:"erro", texto:"Erro ao salvar. Verifique as configurações." });
    } finally { setSaving(false); }
  }

  async function handleEnviar() {
    setSending(true); setMsg(null);
    try {
      await enviarPrazosAgora();
      localStorage.setItem("tg_last_send", String(Date.now()));
      const novo = await getConfiguracaoTelegram();
      setCfg(novo);
      setMsg({ tipo:"ok", texto:"✅ Relatório enviado com sucesso!" });
    } catch (e) {
      setMsg({ tipo:"erro", texto: e.response?.data?.error || "Erro ao enviar." });
    } finally { setSending(false); }
  }

  async function handleTestar() {
    setTesting(true); setMsg(null);
    try {
      await testarTelegram();
      setMsg({ tipo:"ok", texto:"✅ Conexão OK — credenciais válidas." });
    } catch (e) {
      setMsg({ tipo:"erro", texto: e.response?.data?.error || "Erro ao testar conexão." });
    } finally { setTesting(false); }
  }

  if (!form) return (
    <div style={card}>
      <div style={sectionTitle}>Notificações Telegram</div>
      <div style={{ color:"#475569", fontSize:13 }}>Carregando...</div>
    </div>
  );

  const ultimoEnvio = cfg?.telegram_prazos_ultimo_envio;

  return (
    <div style={card}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:18 }}>
        <div style={sectionTitle}>Notificações Telegram</div>
        <div style={{ display:"flex", gap:8 }}>
          <button style={btnTestar} onClick={handleTestar} disabled={testing || !cfg?.telegram_bot_token || !form.chat_id}>
            {testing ? "Testando..." : "🔗 Testar"}
          </button>
          <button style={btnEnviar} onClick={handleEnviar} disabled={sending || !cfg?.telegram_bot_token || !form.chat_id}>
            {sending ? "Enviando..." : "📤 Enviar agora"}
          </button>
        </div>
      </div>

      {/* Toggle ativo */}
      <div style={toggleRow}>
        <div>
          <div style={{ fontSize:13, fontWeight:600, color:"#e2e8f0" }}>Notificações automáticas</div>
          <div style={{ fontSize:11, color:"#475569", marginTop:2 }}>
            {form.ativo ? "Envios automáticos ligados" : "Envios automáticos desligados"}
          </div>
        </div>
        <button style={toggleBtn(form.ativo)} onClick={() => setForm(f => ({ ...f, ativo: !f.ativo }))}>
          {form.ativo ? "ON" : "OFF"}
        </button>
      </div>

      {/* Intervalo + Janela */}
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:14 }}>
        <div>
          <label style={fieldLabel}>Intervalo de envio</label>
          <select style={inputStyle} value={form.intervalo} onChange={e => setForm(f => ({ ...f, intervalo: e.target.value }))}>
            {INTERVALO_OPTS.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
          </select>
        </div>
        <div>
          <label style={fieldLabel}>Horário de início</label>
          <select style={inputStyle} value={form.hora_inicio} onChange={e => setForm(f => ({ ...f, hora_inicio: e.target.value }))}>
            {Array.from({ length:24 }, (_,i) => <option key={i} value={String(i)}>{String(i).padStart(2,"0")}:00</option>)}
          </select>
        </div>
        <div>
          <label style={fieldLabel}>Horário de término</label>
          <select style={inputStyle} value={form.hora_fim} onChange={e => setForm(f => ({ ...f, hora_fim: e.target.value }))}>
            {Array.from({ length:24 }, (_,i) => <option key={i} value={String(i)}>{String(i).padStart(2,"0")}:00</option>)}
          </select>
        </div>
      </div>
      <div style={hintText}>
        Mensagens enviadas entre {form.hora_inicio}:00 e {form.hora_fim}:00. Fora desse período o envio automático é pausado.
      </div>

      {/* Bot Token */}
      <div style={{ marginTop:4 }}>
        <label style={fieldLabel}>
          Bot Token
          {cfg?.telegram_bot_token && <span style={{ color:"#334155", fontWeight:400 }}> · atual: {cfg.telegram_bot_token}</span>}
        </label>
        <input
          style={inputStyle}
          type="password"
          value={form.token}
          onChange={e => setForm(f => ({ ...f, token: e.target.value }))}
          placeholder={cfg?.telegram_bot_token ? "Deixe em branco para manter o atual" : "Cole o token do BotFather..."}
          autoComplete="off"
        />
      </div>

      {/* Chat ID */}
      <div>
        <label style={fieldLabel}>Chat ID (grupo ou pessoal)</label>
        <input
          style={inputStyle}
          value={form.chat_id}
          onChange={e => setForm(f => ({ ...f, chat_id: e.target.value }))}
          placeholder="Ex: -1001234567890 (grupo) ou 123456789 (pessoal)"
        />
        <div style={hintText}>
          Para obter: adicione o bot ao grupo e acesse{" "}
          <span style={{ color:"#22d3ee", fontFamily:"monospace" }}>api.telegram.org/bot{"{TOKEN}"}/getUpdates</span>
        </div>
      </div>

      {/* Último envio */}
      {ultimoEnvio && (
        <div style={ultimoEnvioBox}>
          🕐 Último envio: {new Date(ultimoEnvio).toLocaleString("pt-BR", { day:"2-digit", month:"2-digit", year:"numeric", hour:"2-digit", minute:"2-digit" })}
        </div>
      )}

      {/* Mensagem de status */}
      {msg && <div style={msgBox(msg.tipo)}>{msg.texto}</div>}

      {/* Telegram Pessoal */}
      <TelegramPessoalSection />

      {/* Salvar */}
      <div style={{ display:"flex", justifyContent:"flex-end", marginTop:4 }}>
        <button style={btnPrimario} onClick={handleSave} disabled={saving}>
          {saving ? "Salvando..." : "💾 Salvar configurações Telegram"}
        </button>
      </div>
    </div>
  );
}

/* ─── Telegram pessoal por responsável ──────────────────────────── */

function TelegramPessoalSection() {
  const [open,          setOpen]          = useState(false);
  const [colaboradores, setColaboradores] = useState(null);
  const [editMap,       setEditMap]       = useState({});
  const [saving,        setSaving]        = useState({});
  const [msg,           setMsg]           = useState(null);

  useEffect(() => {
    if (!open || colaboradores !== null) return;
    getColaboradoresTelegram()
      .then(data => {
        setColaboradores(data);
        const m = {};
        data.forEach(c => { m[c.nome] = c.chat_id || ""; });
        setEditMap(m);
      })
      .catch(() => {
        setColaboradores([]);
        setMsg({ tipo:"info", texto:"Endpoint não disponível — configure GET /api/colaboradores/telegram no backend." });
      });
  }, [open, colaboradores]);

  async function salvar(nome) {
    setSaving(s => ({ ...s, [nome]: true }));
    setMsg(null);
    try {
      await setColaboradorTelegram(nome, editMap[nome] || null);
      setColaboradores(prev => prev.map(c => c.nome === nome ? { ...c, chat_id: editMap[nome] || null } : c));
      setMsg({ tipo:"ok", texto:`Chat ID de ${nome} salvo.` });
    } catch {
      setMsg({ tipo:"erro", texto:`Erro ao salvar ${nome}.` });
    } finally {
      setSaving(s => ({ ...s, [nome]: false }));
    }
  }

  return (
    <div style={{ marginTop:8 }}>
      <button
        style={{
          width:"100%", padding:"10px 14px", borderRadius:10, border:"none",
          background: open ? "rgba(167,139,250,0.1)" : "rgba(167,139,250,0.05)",
          color:"#a78bfa", fontSize:12, fontWeight:600, cursor:"pointer",
          display:"flex", justifyContent:"space-between", alignItems:"center",
          transition:"background 0.15s",
        }}
        onClick={() => setOpen(v => !v)}
      >
        <span>📬 Telegram pessoal por responsável</span>
        <span style={{ fontSize:10 }}>{open ? "▼" : "▶"}</span>
      </button>

      {open && (
        <div style={{ marginTop:10, display:"flex", flexDirection:"column", gap:8 }}>
          <div style={hintText}>Cada responsável receberá no próprio Telegram apenas as suas tarefas atrasadas.</div>
          {colaboradores === null && <div style={{ color:"#475569", fontSize:12 }}>Carregando...</div>}
          {msg && (
            <div style={{
              fontSize:11, fontWeight:500,
              color: msg.tipo==="ok" ? "#4ade80" : msg.tipo==="erro" ? "#f87171" : "#60a5fa",
              background: msg.tipo==="ok" ? "rgba(74,222,128,0.07)" : msg.tipo==="erro" ? "rgba(248,113,113,0.07)" : "rgba(96,165,250,0.07)",
              border: `1px solid ${msg.tipo==="ok" ? "rgba(74,222,128,0.2)" : msg.tipo==="erro" ? "rgba(248,113,113,0.2)" : "rgba(96,165,250,0.15)"}`,
              borderRadius:7, padding:"6px 10px",
            }}>{msg.texto}</div>
          )}
          {(colaboradores || []).map(c => (
            <div key={c.nome} style={{ display:"flex", alignItems:"center", gap:8 }}>
              <span style={{ fontSize:11, color:"#94a3b8", minWidth:130, flexShrink:0 }}>{c.nome}</span>
              <input
                style={{ ...inputStyle, fontSize:11, padding:"5px 8px" }}
                value={editMap[c.nome] ?? ""}
                onChange={e => setEditMap(m => ({ ...m, [c.nome]: e.target.value }))}
                placeholder="Chat ID pessoal..."
              />
              <button
                style={{ padding:"4px 10px", borderRadius:7, border:"1px solid rgba(74,222,128,0.3)", background:"rgba(74,222,128,0.07)", color:"#4ade80", fontSize:11, cursor:"pointer", flexShrink:0 }}
                disabled={!!saving[c.nome]}
                onClick={() => salvar(c.nome)}
              >{saving[c.nome] ? "…" : "✓"}</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ─── Estilos ─────────────────────────────────────────────────────── */

const page       = { padding:"28px 32px", display:"flex", flexDirection:"column", gap:20, maxWidth:780 };
const pageTitle  = { color:"#f1f5f9", fontSize:22, fontWeight:700, margin:0 };
const pageSub    = { color:"#475569", fontSize:13, marginTop:4 };
const card       = { background:"rgba(11,22,42,0.72)", backdropFilter:"blur(18px)", border:"1px solid rgba(96,165,250,0.1)", borderRadius:14, padding:"22px 24px", display:"flex", flexDirection:"column", gap:14 };
const sectionTitle = { fontSize:11, fontWeight:700, color:"#cbd5e1", textTransform:"uppercase", letterSpacing:1.2, flexShrink:0 };
const fieldRow   = { display:"flex", alignItems:"center", gap:16 };
const fieldLabel = { display:"block", color:"#94a3b8", fontSize:11, fontWeight:600, marginBottom:5 };
const fieldHint  = { fontSize:11, color:"#334155", marginTop:3 };
const hintText   = { fontSize:10, color:"#334155" };
const numInput   = {
  width:80, padding:"8px 12px", borderRadius:8, textAlign:"center",
  border:"1px solid rgba(96,165,250,0.2)", background:"rgba(11,22,42,0.7)",
  color:"#e2e8f0", fontSize:18, fontWeight:800, outline:"none", colorScheme:"dark",
};
const inputStyle = {
  width:"100%", padding:"8px 11px", borderRadius:8,
  border:"1px solid rgba(96,165,250,0.15)", background:"rgba(11,22,42,0.7)",
  color:"#e2e8f0", fontSize:13, outline:"none", boxSizing:"border-box", colorScheme:"dark",
};
const toggleRow  = { display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 14px", borderRadius:10, background:"rgba(96,165,250,0.04)", border:"1px solid rgba(96,165,250,0.1)" };
const toggleBtn  = ativo => ({ padding:"6px 16px", borderRadius:20, border:"none", background: ativo ? "#4ade80" : "rgba(255,255,255,0.08)", color: ativo ? "#060d1e" : "#475569", fontWeight:800, fontSize:12, cursor:"pointer", transition:"all 0.15s" });
const ultimoEnvioBox = { fontSize:11, color:"#475569", background:"rgba(96,165,250,0.04)", border:"1px solid rgba(96,165,250,0.1)", borderRadius:8, padding:"8px 12px" };
const msgBox = tipo => ({
  fontSize:12, fontWeight:500,
  color: tipo==="ok" ? "#4ade80" : "#f87171",
  background: tipo==="ok" ? "rgba(74,222,128,0.08)" : "rgba(248,113,113,0.08)",
  border: `1px solid ${tipo==="ok" ? "rgba(74,222,128,0.2)" : "rgba(248,113,113,0.2)"}`,
  borderRadius:8, padding:"8px 12px",
});
const btnPrimario  = { padding:"9px 20px", borderRadius:9, border:"none", background:"linear-gradient(135deg,#3b82f6,#06b6d4)", color:"#fff", fontSize:13, fontWeight:700, cursor:"pointer" };
const btnSecundario = { padding:"9px 16px", borderRadius:9, border:"1px solid rgba(96,165,250,0.15)", background:"transparent", color:"#475569", fontSize:13, cursor:"pointer" };
const btnTestar    = { padding:"7px 12px", borderRadius:8, border:"1px solid rgba(96,165,250,0.2)", background:"transparent", color:"#475569", fontSize:11, cursor:"pointer" };
const btnEnviar    = { padding:"7px 14px", borderRadius:8, border:"none", background:"linear-gradient(135deg,#3b82f6,#06b6d4)", color:"#fff", fontSize:11, fontWeight:700, cursor:"pointer" };
